function $q(ctx, selector, callback) {
  ctx.querySelectorAll(selector).forEach((el, index) => {
    callback(el, index, ctx)
  })
}

$q.first = function first(ctx, selector, callback) {
  const el = ctx.querySelector(selector)
  if (el) callback(el, 0, ctx)
}

// Cached query selector
function $cqs(selector, context = document) {
  // Check if the selector is already cached for this context
  if (!$cqs.cache) {
    // If not, create a cache object
    $cqs.cache = new WeakMap()
  }

  // Check if the selector is already in the cache for this context
  if (!$cqs.cache.has(context)) {
    $cqs.cache.set(context, new Map())
  }
  const cache = $cqs.cache.get(context)
  if (!cache.has(selector)) {
    // If not, query the DOM for the context and store the result in the cache
    cache.set(selector, context.querySelector(selector))
  }

  // Return the cached value
  return cache.get(selector)
}

const _HYDRATE_SKIP = Symbol('SKIP')
const FN_ATTR_EFFECTS_LOOKUP = {
  'x-show': (el, result) => {
    const show = !!result
    el.toggleAttribute('hidden', !show)
    // el.style.display = show ? '' : 'none'
  },
  'x-text': (el, result) => {
    el.textContent = result == null ? '' : result
  },
  'x-effect': null,
}
const SUPPORTED_KEYS = Object.keys(FN_ATTR_EFFECTS_LOOKUP)

const _children_cache = new WeakMap()
export const hydrateFromHtml = ({
  container,
  preferCachedChildren = true,
  // tuple of params and args
  context,
}) => {
  const fnAttrsLookup = FN_ATTR_EFFECTS_LOOKUP
  const data = context.reduce(
    (acc, tuple) => {
      acc.params.push(tuple[0])
      acc.args.push(tuple[1])
      return acc
    },
    { params: [], args: [] }
  )

  let els = _children_cache.get(container)
  if (!els || !preferCachedChildren) {
    els = [container].concat(Array.from(container.querySelectorAll(`${SUPPORTED_KEYS.map(x => `[${x}]`).join(', ')}`)))
    _children_cache.set(container, els)
  }

  els.forEach(el => {
    const condFnString = el.getAttribute('x-if')
    if (condFnString) {
      const condFnCacheKey = `__fn_x-if`
      let condFn = el[condFnCacheKey]
      if (condFnString && !condFn) {
        condFn = new Function('$el', '$SKIP', '$cqs', ...data.params, `return (${condFnString})`)
        el[condFnCacheKey] = condFn
      }

      if (condFn) {
        const shouldContinue = condFn(el, _HYDRATE_SKIP, $cqs, ...data.args)
        if (!shouldContinue) return
      }
    }

    for (const fnAttr in fnAttrsLookup) {
      if (!Object.prototype.hasOwnProperty.call(fnAttrsLookup, fnAttr)) {
        continue
      }
      const condAttr = `${fnAttr}-if`

      const ourEffect = fnAttrsLookup[fnAttr]
      const userFnString = el.getAttribute(fnAttr)
      const condFnString = el.getAttribute(condAttr)

      if (!userFnString) {
        continue
      }

      const fnCacheKey = `__fn_${fnAttr}`
      const condFnCacheKey = `__fn_${condAttr}`

      let userFn = el[fnCacheKey]
 
      if (!userFn) {
        // if there is our effect, then we expect the `userFn` to be returnable
        const returnable = !!ourEffect
        const fnbody = returnable ? `return (${userFnString})` : userFnString
        userFn = new Function('$el', '$SKIP', '$cqs', ...data.params, fnbody)
        el[fnCacheKey] = userFn
      }

      let condFn = el[condFnCacheKey]
      if (condFnString && !condFn) {
        condFn = new Function('$el', '$SKIP', '$cqs', ...data.params, `return (${condFnString})`)
        el[condFnCacheKey] = condFn
      }

      try {
        if (condFn) {
          const shouldContinue = condFn(el, _HYDRATE_SKIP, $cqs, ...data.args)
          if (!shouldContinue) continue
        }

        // Run user fn
        const result = userFn(el, _HYDRATE_SKIP, $cqs, ...data.args)
        if (result === _HYDRATE_SKIP) continue

        // Run effect - if any
        if (ourEffect) {
          ourEffect(el, result)
        }
      } catch (e) {
        if (!el.hasAttribute('x-no-err')) {
          console.error('[hydrateFromHtml] :: ', e.message)
        }
      }
    }
  })
}

// ---------------------------------------------------------------

;(() => {
  // get tomorrow's date by `getDateByDayOffset(new Date(), 1)`
  function getDateByDayOffset(date, offset = 1) {
    const next = new Date(date)
    next.setDate(next.getDate() + offset)     
    return next
  }

  let weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  let monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  
  function getBusinessDay(from, days) {
    let result = new Date(from)

    for (let i = 0; i < days; i++) {
      result.setDate(result.getDate() + 1)
  
      const day = result.getDay()
      const saturday = day === 6
      const sunday = day === 0
  
      // If resulting day is saturday, then make it monday by adding 2 more days
      if (saturday) {
        result.setDate(result.getDate() + 2)
      } else if (sunday) {
        // If resulting day is sunday, then make it monday by adding 1 more day
        result.setDate(result.getDate() + 1)
      }
    }
  
    return result
  }
  
  function nth(n) {
    return n + (['st', 'nd', 'rd'][((((n + 90) % 100) - 10) % 10) - 1] || 'th')
  }
  
  function formatDate(date) {
    const weekdayName = weekdays[date.getDay()] // Monday
    const monthName = monthNames[date.getMonth()] // August
    const dayth = nth(date.getDate()) // 15th
  
    // Monday, August 15th
    return weekdayName + ', ' + monthName + ' ' + dayth
  }

  async function fetchGeoLocationAndTime() {
    let date = new Date()
    return fetch('https://accuair-geo.husseyexplores.workers.dev/api/geo').then(r => {
      if (r.headers.has('date')) {
        date = new Date(r.headers.get('date'))
      }
      return r.json()
    })
    .then(geo => ({ geo, date }))
  }

  function fetchCurrentTime() {
    return fetch('/cart.js').then(r => {
      if (r.headers.has('date')) {
        return new Date(r.headers.get('date'))
      }

      return fetch('https://time.akamai.com/?iso')
        .then(r => r.text())
        .then(dateString => new Date(dateString))
    })
  }  

  class EstimatedDate extends HTMLElement {
    constructor() {
      super()
      this.$q = $q.bind(null, this)

      this._attrs = {}
      this._setValidatedAttrs = {
        min: (next) => {
          const num = parseInt(next, 10)
  
          if (!Number.isNaN(num)) {
            this.setAttribute('min', next)
            this._attrs.min = num
            this._calculateMinMaxDate('min')
            return num
          }
        },
        max: (next) => {
          const num = parseInt(next, 10)
  
          if (!Number.isNaN(num)) {
            this.setAttribute('max', next)
            this._attrs.max = num
            this._calculateMinMaxDate('max')
            return num
          }
        }
      }
    }
  
    static get observedAttributes() {
      return ['min', 'max']
    }
  
    attributeChangedCallback(attr, old, latest) {
      if (latest == null) {
        this.removeAttribute(attr)
        this._attrs[attr] = null
        return
      }
    }
  
    get min() {
      return this._attrs.min
    }
  
    set min(next) {
      return this._setValidatedAttrs.min(next)
    }
  
    get max() {
      return this._attrs.max
    }
  
    set max(next) {
      return this._setValidatedAttrs.max(next)
    }
  
    async connectedCallback() {
      this.removeAttribute('x-dehydrated')
      this._attrs = this._attrs || {}

      // consider `today` excluded (-1)
      this._todayUntilHours = Number(this.getAttribute('today-until') || '-1')
      this._calculateDateFrom = new Date()

      if (this.hasAttribute('from-api')) {
        const { geo, date } = await fetchGeoLocationAndTime()
        this._calculateDateFrom = date

        const international = geo?.country !== 'US'
        if (international) {
          const min = this.getAttribute('int-min')
          const max = this.getAttribute('int-max')
          if (min != null) this.setAttribute('min', min)
          if (max != null) this.setAttribute('max', max)
        }
      }
      
      this._attrs = {
        min: parseInt(this.getAttribute('min'), 10),
        max: parseInt(this.getAttribute('max'), 10)
      }

      this._calculateMinMaxDate('min')
      this._calculateMinMaxDate('max')
    }
  
    _calculateMinMaxDate(attr) {
      if (attr !== 'min' && attr !== 'max') {
        return
      }

      if (typeof this._attrs[attr] !== 'number') {
        return
      }
  
      if (Number.isNaN(this._attrs[attr])) {
        return
      }

      const estimatedDate = getBusinessDay(this._calculateDateFrom, this._attrs[attr])
  
      this.$q(
        `[data-${attr}]`,
        (el) => {
          el.textContent = formatDate(estimatedDate)
          if (el.tagName === 'TIME') {
            el.setAttribute('datetime', estimatedDate.toISOString())
          }
        },
        this
      )
    }

    _getCurrentHours(date) {
      if (!this.__dateFormatter) {
        const options = {
          timeZone: this.getAttribute('timezone-name') || 'America/Chicago',
          hour: 'numeric',
          hour12: false,
        }
        this.__dateFormatter = new Intl.DateTimeFormat([], options)
      }

      const currentHours = Number(this.__dateFormatter.format(date))
      return currentHours
    }

    get _calculateDateFrom() {
      return this.__calculateDateFrom
    }

    set _calculateDateFrom(date) {
      this.__calculateDateFrom = date
      const hours = this._getCurrentHours(date)
      
      // If past `todayUntilHours` (eg: 2PM / 14:00) - do not count the current day
      if (hours >= this._todayUntilHours) {
        this.__calculateDateFrom = getDateByDayOffset(this.__calculateDateFrom, 1)
      }
    }
  }

  if (!window.customElements.get('estimated-date')) {
    window.customElements.define('estimated-date', EstimatedDate)
  }

  // Dynamic Event Change Reactor
  class EventReactor extends HTMLElement {
    connectedCallback() {
      this._ac?.abort()
      this._ac = new AbortController()

      this._listenFrom = this.getAttribute('listen-from')
      if (!this._listenFrom) return
      this._listenFrom =  document.getElementById(this._listenFrom)
      if (!this._listenFrom) return
 
      this._hasStaticChildren = !this.hasAttribute('dynamic-childs')

      this._events = this.getAttribute('event')?.split(',').map(raw => {
        const [name, mappedTo = name] = raw.split('->')
        return { name, mappedTo: mappedTo.replace(/\:/g, '_') }
      })
    
      if (!Array.isArray(this._events) || this._events.length === 0) return

      if (this._events.length === 0) return


      this._stateContext = this._events.map((ev, index) => ([ev.mappedTo, null]))

      this._events.forEach((ev, index) => {
        this._listenFrom.addEventListener(ev.name, domEvent => {
          if (!this.isConnected) return

          this._stateContext[index][1] = domEvent.detail
    
          hydrateFromHtml({
            container: this,
            preferCachedChildren: !this._hasStaticChildren,
            context:  [
              ['formatMoney', formatMoney],
              ['$event', domEvent],
              ['$detail', domEvent.detail],
              ...this._stateContext,
            ],
          })
        }, { signal: this._ac.signal })
      })

      this.removeAttribute('x-dehydrated')
    }

    disconnectedCallback() {
      this._ac?.abort()
      this._ac = null
      this._state = null
    }
  }

  if (!window.customElements.get("event-reactor")) {
    window.customElements.define("event-reactor", EventReactor)
  }
})();
// ---------------------------------------------------------------

// Update the cart count on root element so we can make changes via CSS
class CustomCartCount extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const count = parseInt(this.getAttribute('count')) || 0
    const currentCountAttr = document.body.getAttribute('data-cart-count')
    if (currentCountAttr == null || currentCountAttr != count) {
      document.body.setAttribute('data-cart-count', count)
    }
  }
}
customElements.define('custom-cart-count', CustomCartCount);

